export const environment = {
    production: true,
    halloweenPollId: 'gN2tPMKXnQ6T$vJAjCgwDQ==',
    urlAPI: 'https://api.puntoapuntorenault.com/api/',
    blobPublic: 'https://blobpuntoapunto.blob.core.windows.net/prod-puntoapunto-public/',
    issueTrackerKey: 'bd197ef1-d564-42e1-bf45-50229cd98c1d',
  issueTrackerUrl: 'https://issue-tracker.lnkgs.es/',
  recaptchaSiteKey: '6Lc01JQsAAAAABgGfz5Qj126qylNKBn_yuxEbrPs'
  };